import { render, staticRenderFns } from "./AcessarAtaItensView.vue?vue&type=template&id=69db69f6&scoped=true"
import script from "./AcessarAtaItensView.vue?vue&type=script&lang=js"
export * from "./AcessarAtaItensView.vue?vue&type=script&lang=js"
import style0 from "./AcessarAtaItensView.vue?vue&type=style&index=0&id=69db69f6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69db69f6",
  null
  
)

export default component.exports